import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useRemoveBankAccount = (): UseMutationResult<
  unknown,
  unknown,
  { accountId: string }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.Banking);

  const removeBankAccount = async ({ accountId }: { accountId: string }) => {
    const { data } = await treasureApi().delete('/accounts', {
      data: {
        accounts: [{ AccountId: accountId }],
      },
    });

    return data;
  };

  return useMutation(removeBankAccount, {
    onSuccess: () => {
      queryClient.invalidateQueries([ReactQueryKeys.BankAccountsV2]);
      queryClient.invalidateQueries([ReactQueryKeys.BankAccounts]);
      queryClient.invalidateQueries([ReactQueryKeys.ConnectedAccounts]);
    },
  });
};
